import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';
import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { Table } from '@dreryk/react-components';

import { VisitDiagnoses } from '~libs.shared.visit';

import {
   useMedicineSearchDataConfiguration,
   useMedicineSearchTableColumnConfiguration,
} from './MedicineSearchTable.hooks';
import { MedicineSearchDataAccessor, medicineSearchKeyExtractor } from './MedicineSearchTable.utils';

export type MedicineSearchTableProps = {
   patientId: Patient['id'];
   searchText: string;
   onMedicineSelection: (medicine: PatientMedicine) => void;
   visitDiagnoses: VisitDiagnoses;
};

export const MedicineSearchTable = (props: MedicineSearchTableProps): JSX.Element => {
   const dataConfiguration = useMedicineSearchDataConfiguration(props.patientId, props.searchText);
   const columns = useMedicineSearchTableColumnConfiguration({
      patientId: props.patientId,
      onMedicineSelection: props.onMedicineSelection,
      visitDiagnoses: props.visitDiagnoses,
   });

   return (
      <Table<PatientMedicine>
         testId={'medicineSearch'}
         dataConfiguration={dataConfiguration}
         columns={columns}
         keyExtractor={medicineSearchKeyExtractor}
         dataAccessor={MedicineSearchDataAccessor}
      />
   );
};
